import helpers from './../helpers';
import Swiper from 'swiper/js/swiper';

export default class Home {

	constructor () {
		this.loadedVideo = false;
		this.swiperHeader = null;
		if (document.body.classList.contains('homepage')) {
			this.init();
		}
	}

	init () {
		this.initHomeArrow();

		window.addEventListener('resize', this.displayWindowSize.bind(this));
		this.displayWindowSize();
	}

	initHomeArrow () {
		let headerHomeArrow = document.querySelector('#header .hero-arrow.down');
		let topNavBar = document.querySelector('.main-nav');
		if (headerHomeArrow) {
			headerHomeArrow.addEventListener('click', (event) => {
				helpers.scrollToTop(window.pageYOffset + document.querySelector('#content').getBoundingClientRect().top - topNavBar.scrollHeight, 600);
				event.preventDefault();
			});
		}
	}

	displayWindowSize () {
		this.initSwiper();
		this.initVideo();
	}

	initVideo () {
		if (document.querySelector('.video-container') === null) return;

		if (!this.loadedVideo &&
			window.matchMedia('(min-width: 531px)').matches) {
			document.querySelector('.video-container video').setAttribute(
				'poster',
				document.querySelector('.video-container video').dataset.poster
			);
			document.querySelector('.video-container source').setAttribute(
				'src',
				document.querySelector('.video-container source').dataset.src
			);
			this.loadedVideo = true;
		}
	}

	initSwiper () {
		if (document.querySelector('.swiper-container') === null) return;

		if (window.matchMedia('(max-width: 530px)').matches) {
			if (this.swiperHeader === null) {
				this.swiperHeader = new Swiper('.swiper-container', {
					preloadImages: false,
					lazy: {
						loadPrevNext: true,
					},

					simulateTouch: false,
					touchMoveStopPropagation: true,
					passiveListeners: false,

					a11y: {
						enabled: false,
					},

					// Optional parameters
					direction: 'horizontal',
					loop: true,

					// Navigation arrows
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				});
			}
		} else {
			if (this.swiperHeader !== null) {
				this.swiperHeader.destroy();
				this.swiperHeader = null;
			}
		}
	}

}
